import { Link } from "react-router-dom";
import CtaBand from "../components/CtaBand";
import { IconArrow, IconPlug, IconWindow, IconBolt, IconCompass } from "../components/icons";

const SERVICES = [
  { icon: <IconPlug />, title: "Integrations", body: "Connect the tools you already use so your team stops copying data by hand and systems stay in sync." },
  { icon: <IconWindow />, title: "Web apps", body: "Purpose-built internal tools and customer-facing apps — fast, accessible, and yours to keep." },
  { icon: <IconBolt />, title: "Automation", body: "Replace the repetitive, error-prone jobs with reliable automations that run themselves." },
  { icon: <IconCompass />, title: "Consultancy", body: "A second pair of hands on architecture, delivery, and the build-or-buy calls that are hard to reverse." },
];

const STEPS = [
  { title: "Scope", body: "We agree exactly what we're building and why, in plain language, with a fixed price or a clear estimate before any code is written." },
  { title: "Ship a slice", body: "You get a small, working, deployable piece early — not a slideshow. Real software you can click, in your environment." },
  { title: "Iterate", body: "Short cycles, frequent check-ins. You see progress every week and can change direction while it's still cheap to." },
  { title: "Hand over", body: "Documented, tested, and owned by you. No lock-in, no undocumented magic — we build so someone else could maintain it." },
];

export default function Home() {
  return (
    <>
      <section className="hero">
        <div className="container hero__grid">
          <div>
            <p className="eyebrow">Software integration &amp; delivery</p>
            <h1 className="display-xl">
              Move fast,<br /><span className="accent">on purpose.</span>
            </h1>
            <p className="lead hero__sub">
              Agile Software Ltd builds and integrates software for businesses that need
              to move quickly &mdash; without breaking what already works.
            </p>
            <div className="hero__cta">
              <Link to="/contact" className="btn">Start a project <IconArrow /></Link>
              <Link to="/services" className="btn btn--ghost">See what we do</Link>
            </div>
            <div className="hero__meta">
              <span><b>UK-based</b> · limited company</span>
              <span><b>Fixed scope</b> · clear pricing</span>
              <span><b>Handover-ready</b> by default</span>
            </div>
          </div>
          <div className="streakart" aria-hidden="true">
            <span className="bar" /><span className="bar" /><span className="bar" />
            <span className="bar" /><span className="bar" />
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <p className="eyebrow">What we do</p>
          <h2 className="display-lg" style={{ margin: "16px 0 40px", maxWidth: "18ch" }}>
            Four ways we help teams ship.
          </h2>
          <div className="grid grid--2">
            {SERVICES.map((s) => (
              <article className="card" key={s.title}>
                <span className="card__icon">{s.icon}</span>
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </article>
            ))}
          </div>
          <div style={{ marginTop: 28 }}>
            <Link to="/services" className="btn btn--ghost">All services <IconArrow /></Link>
          </div>
        </div>
      </section>

      <section className="section section--charcoal">
        <div className="container">
          <p className="eyebrow">How we work</p>
          <h2 className="display-lg" style={{ margin: "16px 0 14px", maxWidth: "20ch" }}>
            Agile isn&rsquo;t a buzzword here &mdash; it&rsquo;s how we&rsquo;re built.
          </h2>
          <p className="lead" style={{ marginBottom: 44 }}>
            Small steps, working software, and honesty about trade-offs. The same four
            beats on every engagement.
          </p>
          <div className="steps">
            {STEPS.map((s) => (
              <div className="step" key={s.title}>
                <span className="step__num" />
                <div>
                  <h3>{s.title}</h3>
                  <p>{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
